import React from 'react';
import { red500 } from '@prezi/common-design';
import * as Atoms from '../../atoms';
import { Tooltip } from './';
import { localI18n } from '../../../i18n';
const uxCopyTooltip = {
  title: localI18n._("An error has occurred"),
  body: localI18n._("Please try again later.")
};
const ErrorStatus = () => {
  const iconWrapperRef = React.useRef(null);
  const [isTooltipOpen, setTooltipOpen] = React.useState(true);
  React.useEffect(() => {
    const initialDisplayTimer = setTimeout(() => setTooltipOpen(false), 3000);
    return () => {
      clearTimeout(initialDisplayTimer);
    };
  }, []);
  return React.createElement(React.Fragment, null, React.createElement(Atoms.Dumb.HeaderIconWrapper, {
    ref: iconWrapperRef,
    onMouseEnter: () => setTooltipOpen(true),
    onMouseLeave: () => setTooltipOpen(false)
  }, React.createElement(Atoms.Icons.Warning, {
    fill: red500
  })), React.createElement(Tooltip, {
    isOpen: isTooltipOpen,
    triggerRef: iconWrapperRef,
    uxCopy: uxCopyTooltip
  }));
};
export default ErrorStatus;